import {combineReducers} from 'redux';
import ACTION from '../action_constant';

function dashboard(state = {
  shipmentPackages: [],
  carryingPackages: [],
  receivingPackages: []
}, action) {
  switch (action.type) {
    case ACTION.DASHBOARD.ADD_SHIPMENT_PACKAGES:
        return Object.assign({}, state, { shipmentPackages : action.data.shipments,
                                          shippingCount: action.data.shippingCount,
                                          carryingCount: action.data.carryingCount,
                                          receivingCount: action.data.receivingCount
                                        });

    case ACTION.DASHBOARD.ADD_CARRYING_PACKAGES:
        return Object.assign({}, state, { carryingPackages : action.data.shipments,
                                          shippingCount: action.data.shippingCount,
                                          carryingCount: action.data.carryingCount,
                                          receivingCount: action.data.receivingCount
                                        });

    case ACTION.DASHBOARD.ADD_RECEIVING_PACKAGES:
        return Object.assign({}, state, { receivingPackages : action.data.shipments,
                                          shippingCount: action.data.shippingCount,
                                          carryingCount: action.data.carryingCount,
                                          receivingCount: action.data.receivingCount
                                        });

    default:
      return state;
  }
}

module.exports = dashboard;



// WEBPACK FOOTER //
// app/dashboard/dashboard_reducers.jsx